import * as React from "react";
import { styled } from "@mui/material";
import { UrgencyIndicator } from "fe-web-components/urgencyIndicator/urgencyIndicator";
import clsx from "clsx";
import { ConversationRecommendationFragment } from "fe-common/graphql";
import { URGENCY_DATA } from "fe-web-components/data/urgencyData";
import { Urgency } from "shared";
//region [[ Styles ]]

const RecommendationView = styled("div")({});

const Recommendation = styled("div")({
  display: "flex",
  flexFlow: "column",
  margin: "10px 0",
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface PatientRecommendationProps {
  recommendations: ConversationRecommendationFragment[];
  className?: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const PatientRecommendations = ({
  recommendations,
  ...props
}: PatientRecommendationProps) => {
  if (!recommendations?.length) return null;
  const fakeUrgency = Urgency.NOT_URGENT;
  const titleKey = URGENCY_DATA[fakeUrgency].title;
  const textKey = URGENCY_DATA[fakeUrgency].text;

  return (
    <RecommendationView className={clsx("triage-section", props.className)}>
      {recommendations?.map((r, i) => (
        <Recommendation key={"recommendation" + i}>
          <UrgencyIndicator
            urgency={fakeUrgency}
            translate={(key) =>
              key === titleKey
                ? r.feature?.feature?.name
                : key === textKey
                ? r.feature?.feature?.patientDescription
                : null
            }
          />
        </Recommendation>
      ))}
    </RecommendationView>
  );
};
